import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class SidenavService {
	private sidenav: MatSidenav;

	/**
	 * Whether the shell's rail is showing marks only.
	 *
	 * Lives here because it is read OUTSIDE the rail: the Book a Call widget is
	 * fixed to the bottom-left corner and drawn by AppComponent, so it has to
	 * know how much room the corner has. This service is already provided at
	 * the application root and already injected by both of them, so it is the
	 * channel that exists rather than a second one invented for a tooltip.
	 *
	 * The body class the rail also writes is for CSS, which cannot read an
	 * observable; this is for anything that needs the value in TypeScript.
	 */
	private readonly railCollapsedSubject = new BehaviorSubject<boolean>(false);
	public readonly railCollapsed$: Observable<boolean> =
		this.railCollapsedSubject.asObservable();

	public setRailCollapsed(collapsed: boolean): void {
		this.railCollapsedSubject.next(collapsed);
	}

	public setSidenav(sidenav: MatSidenav) {
		this.sidenav = sidenav;
	}

	public open() {
		this.sidenav.open();
	}

	public close() {
		this.sidenav.close();
	}

	public toggle(): void {
		this.sidenav.toggle();
	}
}
